module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h4 class="center">Merge '+
((__t=( mode ))==null?'':__t)+
' <a href="/#person/'+
((__t=( personId ))==null?'':__t)+
'" target="_blank">'+
((__t=( personName ))==null?'':__t)+
'</a></h4>\r\n\r\n<div class="table-responsive well">\r\n    <table class="table table-hover">\r\n        <thead>\r\n        <tr>\r\n            <th>Name</th>\r\n            <th>Created date</th>\r\n            <th>Download</th>\r\n            <th>View</th>\r\n            <th></th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        ';
 _.each(documents, function(document, index) { 
__p+='\r\n        <tr ';
 if (mode == 'to' && !isMergedDocument(document)) { 
__p+=' class="deprecated-header" ';
 } 
__p+=' >\r\n        <td><a href="/#document/'+
((__t=( document.id ))==null?'':__t)+
'" target="_blank">'+
((__t=( document.name ))==null?'':__t)+
'</a></td>\r\n        <td>'+
((__t=( formatDate(document.createdTime) ))==null?'':__t)+
'</td>\r\n        <td>\r\n            <a href="/api/document/download/'+
((__t=( document.id ))==null?'':__t)+
'" class="preview-doc"><span class="clickable glyphicon glyphicon-floppy-disk"/></a>\r\n        </td>\r\n        <td>\r\n            <a href="/api/document/view/'+
((__t=( document.id ))==null?'':__t)+
'" target="_blank" class="preview-doc"><span class="clickable glyphicon glyphicon-eye-open"/></a>\r\n        </td>\r\n        ';
 if (mode == 'from') { 
__p+='\r\n        <td id="'+
((__t=( index ))==null?'':__t)+
'"><span class="control-label glyphicon glyphicon-arrow-right clickable merge" id="'+
((__t=( document.id ))==null?'':__t)+
'" title="Add"></span></td>\r\n        ';
 } 
__p+='\r\n        ';
 if (mode == 'to') { 
__p+='\r\n        <td id="'+
((__t=( index ))==null?'':__t)+
'"><span class="control-label glyphicon glyphicon-remove-circle clickable remove" id="'+
((__t=( document.id ))==null?'':__t)+
'" title="Remove"></span></td>\r\n        ';
 } 
__p+='\r\n        </tr>\r\n        ';
 }) 
__p+='\r\n        </tbody>\r\n    </table>\r\n</div>\r\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/persons/merge-person-documents-view.html
// module id = 495
// module chunks = 0